import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader2, RefreshCcw } from "lucide-react";

import { CitySearch } from "./city-search";
import { CurrencySearch } from "./currency-search";

import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";

import { setDistanceUnit } from "../../redux/pricing/slice";

import { DISTANCE_UNIT } from "../../constants/distance-unit";

import { cn } from "../../utils/lib";

export function NewCityCreationForm() {
  const dispatch = useDispatch();

  // Auth State -- Affiliate's ID
  const authId = useSelector(({ auth }) => auth.user._id);
  const authToken = useSelector(({ auth }) => auth.token);

  const newCityCreationForm = useSelector(
    ({ pricing }) => pricing.newCityCreationForm
  );

  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);

  const handleCreateCity = async () => {
    dispatch({
      type: "EXTRANET_CREATE_CITY",
      payload: {
        callbacks: {
          setIsLoading,
          setIsError,
        },

        // Auth State
        token: authToken,
        affiliateId: authId,

        // Form State
        cityName: newCityCreationForm.cityName,
        currency: newCityCreationForm.currency,
        distanceUnit: newCityCreationForm.distanceUnit,
        country: newCityCreationForm.country,
        longDistancePricePerUnit: newCityCreationForm.longDistancePricePerUnit,
      },
    });
  };

  return (
    <div className="space-y-4">
      <CitySearch className="relative z-20" />
      <CurrencySearch className="relative z-10" />
      <RadioGroup
        className="flex"
        value={newCityCreationForm.distanceUnit}
        onValueChange={(value) => dispatch(setDistanceUnit({ unit: value }))}
      >
        <div className="text-[#4E5665] font-semibold">Distance Unit: </div>
        {DISTANCE_UNIT.map((UNIT) => (
          <div className="flex items-center space-x-1" key={UNIT}>
            <RadioGroupItem
              value={UNIT}
              id={UNIT}
              className="text-white border-white "
            />
            <Label
              className="hover:cursor-pointer text-[#4E5665]"
              htmlFor={UNIT}
            >
              {UNIT}
            </Label>
          </div>
        ))}
      </RadioGroup>

      <Button
        type="button"
        onClick={handleCreateCity}
        disabled={
          !newCityCreationForm.cityNameCorrect ||
          !newCityCreationForm.currencyCorrect ||
          !!newCityCreationForm.cityExistErrorMessage ||
          isLoading
        }
        className={cn(
          "relative z-0 hover:bg-[#1e5cfd] w-full ring-0 focus-visible:ring-0 mt-4 disabled:pointer-events-auto disabled:cursor-not-allowed",
          "bg-button"
        )}
      >
        {isLoading && <Loader2 className="animate-spin" />}
        {isError && <RefreshCcw className="text-red-400" />}
        <span>Create a City</span>
      </Button>

      {isError && (
        <p className="-translate-y-3 text-sm text-red-400">
          Error occurred while creating City, Please try again
        </p>
      )}
    </div>
  );
}
